import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { STAGE } from '../constants/config';
import { logout } from '../store/modules/user/actions';

function onChurnkeyReady(callback) {
  window.dataLayer = window.dataLayer || [];
  const isReady = () =>
    window.churnkey && typeof window.churnkey.check === 'function';

  if (isReady()) {
    callback();
    return;
  }

  const originalPush = window.dataLayer.push;
  window.dataLayer.push = (...args) => {
    originalPush.apply(window.dataLayer, args);
    if (isReady()) {
      callback();
      window.dataLayer.push = originalPush; // Restore original push
    }
  };
}

const useChurnkey = () => {
  const { user, isLoggedIn } = useSelector((s) => s.user);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (global.IS_SERVER) return;
    if (!isLoggedIn) return;

    onChurnkeyReady(() => {
      if (window.churnkey) {
        window.churnkey.check('failed-payment', {
          customerId: user.stripe_id,
          authHash: user.churnkey_auth_hash,
          appId: '162fhfql3',
          provider: 'stripe',
          mode: STAGE === 'prod' ? 'live' : 'test',
          softWall: false, // Allow users to exit the wall
          gracePeriodDays: 0, // Days before enforcing hard wall
          forceCheck: false, // Skip caching (not recommended)
          handleLogout() {
            dispatch(logout());
            window.location.href = '/login';
          },
          handleSupportRequest() {
            window.Intercom(
              'showNewMessage',
              'My account is suspended due to failed payment. Contact the Support Team.',
            );
            window.churnkey.hide();
          },
          handleCancel() {
            history.push('/settings/subscription');
            window.churnkey.hide();
          },
        });
      }
    });
  }, [isLoggedIn]);
};

export default useChurnkey;
